import { createSlice } from "@reduxjs/toolkit";
import { defaultPage, defaultRowsPerPage } from "../../../Utils/constants";
import { getDocNumbering } from "./thunk";
import { act } from "react";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../Utils/dateFormater";

const initialState = {
  loadingDocNumberingNo: false,
  docNumberingNo: "",
  changeTransactionStatus: true,
  transactionDate: dateFormater(new NepaliDate()),
};

export const docNumberingSlice = createSlice({
  name: "docNumbering",
  initialState,
  reducers: {
    setTransactionDate: (state, action) => {
      state.transactionDate = action.payload;
    },
    clearDocNumbering: (state, { payload }) => {
      state.docNumberingNo = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDocNumbering.pending, (state) => {
      state.loadingDocNumberingNo = true;
      state.docNumbering = "";
    });
    builder.addCase(getDocNumbering.fulfilled, (state, action) => {
      state.loadingDocNumberingNo = false;
      state.docNumbering = action.payload?.data?.[0]?.sequenceNumber || "";
    });
    builder.addCase(getDocNumbering.rejected, (state) => {
      state.loadingDocNumberingNo = false;
      state.docNumberingNo = "";
    });
  },
});

// export actions that does not involve api calls
export const { setTransactionDate, clearDocNumbering } = docNumberingSlice.actions;

// export reducer
export default docNumberingSlice.reducer;
